import { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";

function Question({ id, title, info }: any) {
  const [expanded, setExpanded] = useState(false);
  return (
    <article
      className={`group overflow-hidden rounded-2xl border backdrop-blur-md transition-all duration-300 ${
        expanded
          ? "border-[#f30543]/40 bg-white/[0.06] shadow-[0_8px_30px_rgba(243,5,67,0.12)]"
          : "border-white/10 bg-white/[0.03] hover:border-white/20 hover:bg-white/[0.05]"
      }`}
    >
      <header
        onClick={() => setExpanded(!expanded)}
        className="flex cursor-pointer items-center justify-between gap-4 p-5 max-sm:p-4"
      >
        <h4 className="flex items-center gap-4 text-[16px] font-semibold text-white max-sm:gap-3 max-sm:text-[14px]">
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[13px] font-bold transition-all duration-300 max-sm:h-7 max-sm:w-7 ${
              expanded
                ? "bg-[#f30543] text-white shadow-[0_4px_14px_rgba(243,5,67,0.4)]"
                : "bg-white/[0.06] text-[#f30543]"
            }`}
          >
            {id}
          </span>
          <span
            className={`transition-colors duration-300 ${
              expanded ? "text-white" : "text-white/85 group-hover:text-white"
            }`}
          >
            {title}
          </span>
        </h4>
        <button
          className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-all duration-300 max-sm:h-8 max-sm:w-8 ${
            expanded
              ? "bg-[#f30543] text-white"
              : "bg-white/[0.06] text-white/70 hover:bg-white/15 hover:text-white"
          }`}
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(!expanded);
          }}
          aria-label="Toggle answer"
        >
          <AiOutlinePlus
            className={`transition-transform duration-300 ${
              expanded ? "rotate-45" : ""
            }`}
          />
        </button>
      </header>

      {/* smooth expand/collapse */}
      <div
        className={`grid transition-all duration-300 ease-out ${
          expanded ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <div className="mx-5 mb-5 rounded-xl border-l-2 border-[#f30543]/40 bg-black/20 px-4 py-3.5 max-sm:mx-4">
            <p className="text-[14.5px] leading-relaxed text-white/65">
              {info}
            </p>
          </div>
        </div>
      </div>
    </article>
  );
}

export default Question;
